import { render, staticRenderFns } from "./readIDCardModal.vue?vue&type=template&id=ded8d68c&scoped=true"
import script from "./readIDCardModal.vue?vue&type=script&lang=js"
export * from "./readIDCardModal.vue?vue&type=script&lang=js"
import style0 from "./readIDCardModal.vue?vue&type=style&index=0&id=ded8d68c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded8d68c",
  null
  
)

export default component.exports